export const SET_IS_LOADING = "COMPANIES/SET_IS_LOADING";
export const SET_COMPANY_LIST = "COMPANIES/SET_COMPANY_LIST";
export const COMPANY_LIST_ADD_ITEM = "COMPANY_LIST_ADD_ITEM";
export const COMPANY_LIST_UPDATE_ITEM = "COMPANY_LIST_UPDATE_ITEM";
